// src/components/pages/ShopHarvest.js
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SeoHead from '../seo/SeoHead';
import ShopHarvestHero from '../main/ShopHarvestHero';
import ShopHarvestItems from '../main/ShopHarvestItems';
import HarvestWaitlist from '../main/HarvestWaitlist';
import { bottles } from '../../data/Bottles';

export default function ShopHarvest() {
  const { year } = useParams();

  // scroll to top on mount / year change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [year]);

  // check if we have any bottles for this harvest year
  const hasHarvest = bottles.some(b => b.harvestYear === year);

  // SEO meta values
  const title = `Shop Harvest ${year} – Marrakech Reserve`;
  const description = hasHarvest
    ? `Explore Marrakech Reserve’s limited‑edition ${year} olive oil harvest. Shop small‑batch, cold‑pressed extra‑virgin olive oils from our estate groves.`
    : `Join the waitlist for Marrakech Reserve’s ${year} harvest. Be the first to get notified when our exclusive ${year} extra‑virgin olive oils drop.`;
  const url = `https://marrakech-reserve.com/harvest/${year}`;
  const keywords = [
    `${year} harvest olive oil`,
    'limited edition olive oil',
    'Marrakech Reserve harvest',
    'extra virgin olive oil',
    'small batch olive oil',
    'Moroccan olive oil',
    'estate-grown olive oil',
    `${year} olive oil release`
  ].join(', ');


  return (
    <>
      <SeoHead
        title={title}
        description={description}
        url={url}
        keywords={keywords}
      />

      
      <ShopHarvestHero harvestYear={year} />
      {hasHarvest
        ? <ShopHarvestItems harvestYear={year} />
        : <HarvestWaitlist harvestYear={year} />
      }
      
    </>
  );
}
